import cn from 'classnames';
import { useMemo } from 'react';

import type { BatchState } from 'models/batches';
import type { PayoutState } from 'models/payout';
import type { PayoutDraftState } from 'models/payoutDrafts';
import type {
  TagStyleParams,
  WithdrawalRequestStatus
} from 'models/withdrawal';

type AcceptedStatuses =
  | WithdrawalRequestStatus[]
  | PayoutState[]
  | PayoutDraftState[]
  | BatchState[];

export const StatusTag = ({
  status,
  statuses
}: {
  status: string;
  statuses: AcceptedStatuses;
}) => {
  const statusProps = useMemo(() => {
    const defaultStyle: TagStyleParams = {
      color: 'bg-status-neutral'
    };

    const defaultLabel = status.split('_').join(' ');

    const statusFound = statuses.find((s) => s.value === status);
    const style = Object.values(statusFound?.style ?? defaultStyle).join(' ');
    const label = statusFound?.label ?? defaultLabel;

    return {
      style,
      label
    };
  }, [status, statuses]);

  return (
    <div className="flex h-7 justify-end">
      <div
        data-testid={STATUS_TAG_TEST_ID}
        className={cn(
          'h-fit rounded-2xl px-2 py-1 text-center text-sm first-letter:capitalize',
          statusProps.style
        )}
      >
        {statusProps.label}
      </div>
    </div>
  );
};

export const STATUS_TAG_TEST_ID = 'status-tag';
